var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleArrowLeftGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.9941,
    cy: 12.2422,
    r: 9.375,
    stroke: "#6F706F",
    strokeWidth: 1.25
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_357_4616)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8247 16.96L10.0955 12.0757",
    stroke: "#6F706F",
    strokeWidth: 1.58629,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8247 7.19193L10.0955 12.0762",
    stroke: "#6F706F",
    strokeWidth: 1.58629,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_357_4616"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.77778,
    height: 16,
    fill: "white",
    transform: "matrix(-1 0 0 1 17 4.24219)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleArrowLeftGray);
export default __webpack_public_path__ + "static/media/circle-arrow-left-gray.04bc9ef91ff95a0ca2c5847cd6a037c6.svg";
export { ForwardRef as ReactComponent };